import { GetterTree } from 'vuex';
import { StateInterface } from '../index';
import { StatisticsStateInterface } from './state';

const getters: GetterTree<StatisticsStateInterface, StateInterface> = {
  period(state: StatisticsStateInterface) {
    return state.period;
  },
  loading(state: StatisticsStateInterface) {
    return (
      state.loading.delivery ||
      state.loading.validation ||
      state.loading.inProcess
    );
  },
  deliveryLoading(state: StatisticsStateInterface) {
    return state.loading.delivery;
  },
  validationLoading(state: StatisticsStateInterface) {
    return state.loading.validation;
  },
  inProcessLoading(state: StatisticsStateInterface) {
    return state.loading.inProcess;
  },
  validationFailures(state: StatisticsStateInterface) {
    return state.validationFailures;
  },
  validationSuccess(state: StatisticsStateInterface) {
    return state.validationSuccess;
  },
  deliveredPostings(state: StatisticsStateInterface) {
    return state.deliveredPostings;
  },
  deliveredNewPostings(state: StatisticsStateInterface) {
    return state.deliveredNewPostings;
  },
  deliveryFailures(state: StatisticsStateInterface) {
    return state.deliveryFailures.count;
  },
  inProcessPostings(state: StatisticsStateInterface) {
    return state.inProcessPostings;
  },
  getPendingPostings(state: StatisticsStateInterface) {
    return state.pendingPostings;
  },
};

export default getters;
